export default __webpack_public_path__ + "static/media/review.01c902f4.png";